export default __webpack_public_path__ + "static/benify-971e344cc91a7b51b79855488d930ca3.png";